import React from 'react';

const DataConcept = (props) => {
  return (
    <div>
      <p className="step-p">Each block can store data against it.</p>

      <p className="step-p">In cryptocurrencies such as Bitcoin, the data would include money transactions.</p>
    </div>
  );
};

export default DataConcept;


// WEBPACK FOOTER //
// ./src/steps/data/data-concept.js